export default __webpack_public_path__ + "static/media/CoronaInTheWorld.17e87302.PNG";